import { faPencil } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, DashboardModule, DashboardModuleListItem, Link,
} from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'

interface PortalSettingsProps {
  campaignId: number,
}

const PortalSettings = (props: PortalSettingsProps) => {
  const { campaignId } = props

  const campaignPayload = useCampaign({ id: campaignId })
  const {
    campaign: { data },
    callbacks: { editCampaignPortalDataModal },
    incomingPortal: { title },
  } = campaignPayload

  const {
    agent_id: incomingAgentId,
    external_api_id: externalApiId,
    outgoing_id: outgoingUniqueId,
    secondary_portal_id: secondaryPortalId,
    unique_id: incomingUniqueId,
  } = data || {}

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      headerRight={(
        <Link greyLink onClick={editCampaignPortalDataModal} textProps={{ fontSize: 'small' }}>
          <FontAwesomeIcon icon={faPencil} />
        </Link>
      )}
      title="Portal Settings"
    >
      <Box flexDirection="column">
        <DashboardModuleListItem title="Incoming Portal">
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.TertiaryText>{title || 'Not Syncing'}</DashboardModuleListItem.TertiaryText>
        </DashboardModuleListItem>

        <DashboardModuleListItem title="Incoming Agent ID">
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.TertiaryText>{incomingAgentId || 'Not Set'}</DashboardModuleListItem.TertiaryText>
        </DashboardModuleListItem>

        <DashboardModuleListItem title="Incoming Unique ID">
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.TertiaryText>{incomingUniqueId || 'Not Set'}</DashboardModuleListItem.TertiaryText>
        </DashboardModuleListItem>

        <DashboardModuleListItem title="Outgoing Unique ID">
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.TertiaryText>{outgoingUniqueId || 'Not Set'}</DashboardModuleListItem.TertiaryText>
        </DashboardModuleListItem>

        {externalApiId && (
          <DashboardModuleListItem title="External API ID">
            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.TertiaryText>{externalApiId || 'Not Set'}</DashboardModuleListItem.TertiaryText>
          </DashboardModuleListItem>
        )}

        {secondaryPortalId && (
          <DashboardModuleListItem
            title="Secondary Portal ID"
          >
            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.TertiaryText>
              {secondaryPortalId || 'Not Set'}
              {/*
             // @ts-expect-error TS2339 */}
            </DashboardModuleListItem.TertiaryText>
          </DashboardModuleListItem>
        )}
      </Box>
    </DashboardModule>
  )
}

export default PortalSettings
